var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useEffect } from 'react';
import classNames from 'classnames';
import { getTokenDetails } from '@sovryn/contracts';
import { applyDataAttr } from '@sovryn/ui';
import { getTokenDisplayName } from '../../../constants/tokens';
import styles from './AssetRenderer.module.css';
export const AssetRenderer = ({ asset, showAssetLogo, assetClassName, className, dataAttribute, logoClassName, }) => {
    const [logo, setLogo] = useState(undefined);
    useEffect(() => {
        const getLogo = () => __awaiter(void 0, void 0, void 0, function* () {
            return yield getTokenDetails(asset)
                .then(item => setLogo(item.icon))
                .catch(() => setLogo(''));
        });
        showAssetLogo && getLogo();
    }, [asset, showAssetLogo]);
    return (React.createElement("div", Object.assign({ className: classNames(styles.container, className) }, applyDataAttr(dataAttribute)),
        showAssetLogo && logo && (React.createElement("div", { className: classNames(styles.assetLogo, logoClassName), dangerouslySetInnerHTML: { __html: logo } })),
        React.createElement("span", { className: classNames(styles.asset, assetClassName) }, getTokenDisplayName(asset))));
};
